<template>
    <div>
        <div class="breadcrumb-container">
            <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
        </div>
        <div class="header header-container">
            <div class="text-header">
                {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.updateAttendance') }}
            </div>
            <div>
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-4"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.cancel') }}
                </v-btn>
                <v-btn
                    :disabled="btnDisabled"
                    :class="btnDisabled ? 'btn-inactive' : 'btn-active'"
                    @click="update()"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.save') }}
                </v-btn>
            </div>
        </div>
        <div class="attendance-form-container locale-font">
            <v-card class="attendance-profile content-container">
                <v-container class="pa-attendance-review">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.profile') }}
                    </v-row>
                    <v-row>
                        <v-col cols="3" class="pt-0 profile-container">
                            <upload-image
                                :canDelete="false"
                                :isEditing="false"
                                :img="imgProfile(form.employeeImg)"  />
                        </v-col>
                        <v-col cols="9" class="pt-0">
                            <v-row>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.employeeId') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.employeeNo }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.employeeFullname') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.employeeFullname }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.email') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.email }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.position') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.position }}</div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.bureau') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.bureau }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="attendance-status content-container">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>
                    <v-container class="pa-attendance-review">
                        <v-row class="ma-0 status-card-header">
                            <div>
                                {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.status') }}
                            </div>
                            <div class="date-data">
                                {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.date') }}: {{form.date}}
                            </div>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    v-model="form.checkinTime"
                                    autocomplete="off"
                                    :label="$vuetify.lang.t('$vuetify.manageAttendanceForm.checkinTime')"
                                    type="time"
                                    ref="checkIn"
                                    :rules="ruleCheckin"
                                    placeholder=""
                                    :change="checkTimeChange()"
                                    :error-messages="messageErrorCheckin">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card>
            <v-card class="activity-log content-container">
                <v-container class="pa-attendance-review">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.activityLog') }}
                    </v-row>
                    <div
                        v-if="form.activityLogs.length > 0"
                        class="custom-scrollbar">
                        <v-timeline
                            align-top
                            dense>
                            <v-timeline-item
                                v-for="(item, i) in form.activityLogs" :key="i"
                                small>
                                <div class="activity-label">{{ createActivityDateTime(item) }}</div>
                                <div class="activity-text">{{ createActivityMessage(item) }}</div>
                            </v-timeline-item>
                        </v-timeline>
                    </div>
                    <div v-else>
                        <div class="no-data">
                            {{ $vuetify.lang.t('$vuetify.manageAttendanceForm.thereIsNoActivityLog') }}
                        </div>
                    </div>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'

export default {
    name: 'ManageAttendanceForm',

    components: {
        UploadImage
    },

    computed: {
        breadcrumbsItem () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.inquiry.inquiryAndAttendance'),
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'ManageAttendance'
                    }
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.manageAttendanceForm.updateAttendance'),
                    disabled: true
                }
            ]
        },

        ruleCheckin () {
            return [
                value => !!value || this.$vuetify.lang.t('$vuetify.manageAttendanceForm.thisFieldIsRequired'),
                value => (this.form.checkinTime > this.form.startTime) || `${this.$vuetify.lang.t('$vuetify.manageAttendanceForm.errorSelectTime')} ${this.form.startTime}.`
            ]
        }
    },

    data () {
        return {
            form: {
                employeeImg: null,
                employeeNo: null,
                employeeFullname: null,
                email: null,
                position: null,
                bureau: null,
                date: null,
                startTime: null,
                checkinTime: null,
                activityLogs: []
            },
            attendanceId: null,
            valid: true,
            messageErrorCheckin: null,
            checkinTime: null,
            btnDisabled: true
        }
    },

    methods: {
        imgProfile (img) {
            if (img) {
                return img
            } else {
                return profileDefault
            }
        },

        async loadData (id) {
            this.$store.dispatch('setLoading', true)
            const url = `attendance/info/${id}`
            const res = await this.axios.get(url)
            this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                this.form = res.data.data
                this.checkinTime = this.form.checkinTime
            }
        },

        cancel () {
            this.$router.push({ path: '/inquiry-and-attendance/manage-attendance' }, () => {})
        },

        async update () {
            if (!this.$refs.form.validate()) {
                return
            }
            await this.updateAttendance()
        },

        async updateAttendance () {
            this.$store.dispatch('setLoading', true)
            const url = `attendance/update/${this.attendanceId}`
            const form = {
                employeeNo: this.form.employeeNo,
                employeeFullname: this.form.employeeFullname,
                bureau: this.form.bureau,
                position: this.form.position,
                checkinDate: this.form.date,
                checkinTime: this.form.checkinTime
            }

            const res = await this.axios.put(url, form)
            this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.manageAttendanceForm.congratulation'),
                    text: res.data.msg,
                    type: 'success'
                })
                this.cancel()
            } else {
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.manageAttendanceForm.errorMessage'),
                    text: this.$vuetify.lang.t('$vuetify.manageAttendanceForm.errorSelectTime'),
                    type: 'error'
                })
            }
        },

        createActivityDateTime (item) {
            return `${item.date} ${item.time}`
        },

        createActivityMessage (item) {
            return this.$vuetify.lang.t('$vuetify.manageAttendanceForm.activityMessage').replace('$checkinTime', item.checkinTime).replace('$userName', item.username)
        },

        checkTimeChange () {
            this.btnDisabled = this.checkinTime === this.form.checkinTime
        }
    },

    async mounted () {
        const { id } = this.$route.params
        if (id) {
            this.attendanceId = id
            await this.loadData(this.attendanceId)
        }
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (this.attendanceId) {
                    await this.loadData(this.attendanceId)
                }
                this.$utils.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .header-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;

        .btn-active {
            color: white;
        }
        .btn-inactive {
            color: #6c6c6c;
            background-color: #f6cbba !important;
        }
    }

    .pa-attendance-review {
        padding: 20px 40px 40px 40px;
    }

    .attendance-form-container {
        display: grid;
        min-height: 100%;
        height: 100%;
        margin-bottom: 1rem;
        grid-gap: 25px;
        grid-template-columns: calc(60% - 12.5px) calc(40% - 12.5px);
        color: white;

        .card-header {
            font-size: 24px;
            margin-bottom: 20px !important;
        }

        .status-card-header {
            font-size: 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .date-data {
                font-size: 16px;
            }
        }

        .form-label {
            font-size: 14px;
            color: #6c6c6c;
            line-height: 1.29;
            margin-bottom: 5px;

            &:not(:first-child) {
                margin-top: 23px;
            }
        }

        .form-text {
            font-family: 'Roboto';
            font-size: 16px;
            line-height: 1.19;
            color: #131410;
        }

    }

    .attendance-profile {
        grid-column: 1 / 1;
        grid-row: 1 / 3;
    }

    .attendance-status {
        grid-column: 2 / 2;
        grid-row: 1 / 3;
    }

    .activity-log {
        grid-column: 1 / 3;
        grid-row: 3 / 3;
    }

    .no-data {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 40px;
        font-size: 22px;
        font-weight: 500;
        color: #6c6c6c;
    }

    .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .custom-scrollbar {
        overflow-y: scroll;
        height: 100vh;
        max-height:220px
    }

    .custom-scrollbar::-webkit-scrollbar {
        width: 12px;
        background-color: #F5F5F5;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #555;
    }

    .custom-scrollbar::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #F5F5F5;
    }

    .content-container {
        box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
        border-radius: 15px !important;
    }

    .activity-label {
        font-size: 16px;
        color: #131410;
    }

    .activity-text {
        font-size: 16px;
        color: #6c6c6c;
    }

    .upload-image-container {
        width: 120px;
    }

    ::v-deep .breadcrumb-container .v-breadcrumbs {
        padding-bottom: 18px;
    }
</style>
